import React, {useEffect, useState} from "react";
// import MegaMenu from "../../../mega-menu/corals/mega-menu";
import styles from './navBar.module.css'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope, faGlobe} from "@fortawesome/free-solid-svg-icons";
import MegaMenuV3 from "../../../mega-menu/v3/megaMenuV3";
import BurgerMenu from "../../../common/burgermenu/burgermenu";
import MegaMenuV2 from "../../../mega-menu/v2/MegaMenuV2";
import {useLocation} from "react-router-dom";

const Navbar: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        document.body.style.overflow = mobileMenuOpen ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [mobileMenuOpen]);

    const toggleMenu = () => setIsOpen(prev => !prev);

    const toggleMobileMenuOpen = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    }

    useEffect(() => {
        // Close mobile menu whenever the route changes
        setMobileMenuOpen(false);
    }, [location.pathname]);

    return (
        <>
            {/* Fixed top bar - always visible */}
            <nav className={`${styles.navContainer} navbar navbar-expand-lg navbar-light bg-black fixed-top`}>
                <div className={styles.topBar}>

                    <a className="nav-link px-3" href="/">
                        <img
                            src="/logo512.png"
                            alt="Logo placeholder"
                            className={styles.logo}
                        />
                    </a>

                    {/* Desktop menu stays as-is */}
                    <div className="d-none d-lg-flex collapse navbar-collapse justify-content-center"
                         id="navbarNavDropdown">
                        <ul className={`navbar-nav w-100 justify-content-center ${styles.centerMenu}`}>
                            <li className={`nav-item ${styles.navItem}`}>
                                <a className="nav-link px-5" href="/">Home</a>
                            </li>

                            <li className={`nav-item dropdown ${styles.navItem}`}>
                                <div className="px-5">
                                    <MegaMenuV2/>
                                </div>
                            </li>
                            <li className={`nav-item ${styles.navItem}`}>
                                <a className="nav-link px-5" href="/inverts">Inverts</a>
                            </li>
                            <li className={`nav-item ${styles.navItem}`}>
                                <a className="nav-link px-5" href="/contact">Contact</a>
                            </li>
                        </ul>

                        <ul className="navbar-nav ms-auto">
                            {/*<li className={`nav-item ${styles.navItem}`}>*/}
                            {/*    <a className="nav-link px-3" href="/contact">Contact</a>*/}
                            {/*</li>*/}
                            <li className={`nav-item ${styles.navItem}`}>
                                <a className="nav-link px-3" href="#">
                                    <span className="d-flex align-items-center">
                                        En
                                        <FontAwesomeIcon className="ms-2" icon={faGlobe} size="1x"/>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div  className={styles.menu_icon_container} onClick={toggleMobileMenuOpen}>
                        <BurgerMenu clicked={mobileMenuOpen}/>
                    </div>
                </div>
            </nav>

            {/* Mobile overlay menu */}
            <div
                className={`${styles.mobileOverlay} ${mobileMenuOpen ? styles.mobileOverlayOpen : ''}`}
                onClick={toggleMobileMenuOpen}
            >
                <div className={styles.mobileOverlayContent} onClick={e => e.stopPropagation()}>
                    <ul className={`navbar-nav w-100 justify-content-center ${styles.centerMenu}`}>
                        <li className={`nav-item ${styles.navItem}`}>
                            <a className={`nav-link px-3 ${styles.mobileLink}`} href="/" onClick={toggleMenu}>Home</a>
                        </li>
                        <li className={`nav-item dropdown ${styles.navItem}`}>
                            <div className={`px-3 ${styles.mobileMega}`}>
                                <MegaMenuV3/>
                            </div>
                        </li>
                        <li className={`nav-item ${styles.navItem}`}>
                            <a className={`nav-link px-3 ${styles.mobileLink}`} href="/inverts"
                               onClick={toggleMenu}>Inverts</a>
                        </li>
                    </ul>

                    <ul className={`navbar-nav ms-auto ${styles.mobileRightNav}`}>
                        {/*<li className={`nav-item ${styles.navItem}`}>*/}
                        {/*    <a className={`nav-link px-3 ${styles.mobileLink}`} href="/contact">Contact</a>*/}
                        {/*</li>*/}
                        <li className={`nav-item ${styles.navItem}`}>
                            <a className={`nav-link px-3 ${styles.mobileLink}`} href="#">
                                <span className="d-flex align-items-center gap-2">
                                    <FontAwesomeIcon className="ms-2" icon={faGlobe} size="1x"/>
                                    En
                                </span>
                            </a>
                        </li>
                        <li className={`nav-item ${styles.navItem}`}>
                            <a className={`nav-link px-3 ${styles.mobileLink}`} href="/contact">
                                <span className="d-flex align-items-center gap-2">
                                    <FontAwesomeIcon className="ms-2" icon={faEnvelope} size="1x"/>
                                    Contact
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Navbar;